import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { GrantAccessFlagProps } from '../src/GrantAccessFlag.tsx';

export const GrantAccessFlagLoader: LoadableType<Omit<GrantAccessFlagProps, 'flags'>> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-GrantAccessFlag" */ '../src/GrantAccessFlag.tsx'
				)
			).GrantAccessFlag,
	});
